<template>
	<div>
		<h3 class="text-center">Distribuzione consumi (%)</h3>
		<div id="yearly-slots-chart" style="height: 500px"></div>
	</div>
</template>
<script>
import * as am4core from "@amcharts/amcharts4/core";
import * as am4charts from "@amcharts/amcharts4/charts";

export default {
	name: "YearlySlotsChart",
	props: ['data'],
	data() {
		return {
			colors: this.$store.state.colors,	
		}
	},
	mounted() {
		var chart = am4core.create("yearly-slots-chart", am4charts.XYChart);

		/**
		 * F1 is the sum / sum(F1, F2, F3)
		 */
		/**
		 * [
			{
				"slot": "F1",
				"value": 18480,
				"year": 2021
			},
			{
				"slot": "F2",
				"value": 14160,
				"year": 2021
			},
			{
				"slot": "F3",
				"value": 24960,
				"year": 2021
			},
			{
				"slot": "F1",
				"value": 16632,
				"year": 2022
			},
			{
				"slot": "F2",
				"value": 12744,
				"year": 2022
			},
			{
				"slot": "F3",
				"value": 22464,
				"year": 2022
			}
		]
		 */
		
		chart.data = this.data;
	
		let categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
		categoryAxis.dataFields.category = "slot";
		categoryAxis.renderer.grid.template.location = 0;

		let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
		valueAxis.min = 0;

		const years = [...new Set(chart.data.map((item) => item.year))];
		years.forEach((year, index) => {
			var seriesColor = this.colors[index];
			const series = chart.series.push(new am4charts.ColumnSeries());
			series.dataFields.valueY = "value";
			series.dataFields.categoryX = "slot";
			series.name = year + '';
			series.stacked = false;
			series.data = this.getPercentByYear(year);
			series.columns.template.tooltipText = "{name}: [bold]{valueY}[/]";
			series.stroke = am4core.color(seriesColor);
			series.columns.template.fill = am4core.color(seriesColor);
		})

		chart.legend = new am4charts.Legend();
	},
	methods: {		
		getPercentByYear(year) {
			const total = this.data.filter(e => e.year == year).reduce((a, b) => a + b.value, 0)
			const F1 = this.data.filter(e => e.year == year && e.slot == 'F1').reduce((a, b) => a + b.value, 0)
			const F2 = this.data.filter(e => e.year == year && e.slot == 'F2').reduce((a, b) => a + b.value, 0)
			const F3 = this.data.filter(e => e.year == year && e.slot == 'F3').reduce((a, b) => a + b.value, 0)

			return [{
				"slot": "F1",
				"value": F1 / total * 100,
				"year": year
			},
			{
				"slot": "F2",
				"value": F2 / total * 100,
				"year": year
			},
			{
				"slot": "F3",
				"value": F3 / total * 100,
				"year": year
			}]
		}
	},
	computed: {		
		monthsNames() {
			return this.$store.state.utils.months;
		}
	}
}
</script>


// WEBPACK FOOTER //
// src/components/BillAudit/Charts/YearlySlotsChart.vue